const passwordClientDelete = 'DEL161116!'
const passwordSoaDelete = 'DEL161116!'
const passwordUsersDelete = 'DEL161116!'

export {passwordClientDelete, passwordSoaDelete, passwordUsersDelete}



// WEBPACK FOOTER //
// ./src/constants/passwordForDelete.js